
    <div class="reply-loader" *ngIf="_loading || !data">
      <i class="fal fa-spinner fa-spin" [hidden]="_error"></i>
      <i class="fal fa-exclamation-triangle" [hidden]="!_error"></i>
    </div>
    <ng-container *ngIf="!_loading && data">
      <div class="verify-seed-dice-numbers">
        <div class="dice-numbers">0</div>
        <div class="dice-numbers">25</div>
        <div class="dice-numbers">50</div>
        <div class="dice-numbers">75</div>
        <div class="dice-numbers">100</div>
      </div>

      <div class="dice-slider-wrap">
        <div class="result-wrapper">
          <div
            class="slider-result"
            *ngIf="data.result != null"
            [ngClass]="{ red: data.result > this.data.slider }"
            [ngStyle]="{ left: data.result + '%' }"
          >
            {{ data.result.toFixed(2) }}
          </div>
        </div>

        <input
          title="Slider"
          class="dice-slider red"
          type="range"
          min="1"
          max="99"
          step="1"
          [value]="data.slider"
          (ngModelChange)="changeSlider($event)"
          [style.background]="sliderStyleBg"
          disabled
        />
      </div>
    </ng-container>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-dice.component.ts.ReplyDiceComponent.html